import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  it: {
    translation: {
      nav: {
        home: 'Home',
        events: 'Eventi',
        gallery: 'Galleria',
        about: 'Chi Siamo',
        contact: 'Contatti',
        admin: 'Admin',
        corsoOsmand: 'Corso OsmAnd'
      },
      hero: {
        title: 'Vivi l\'Avventura Offroad',
        subtitle: 'DAL 2011 ORGANIZZIAMO TOUR OFFROAD IN EUROPA, AFRICA E SUDAMERICA',
        cta: 'Scopri gli Eventi'
      },
      events: {
        title: 'Eventi',
        upcoming: 'Prossimi Eventi',
        filter: 'Filtra per tipo',
        all: 'Tutti',
        enduring: 'Enduring',
        tour: 'Tour',
        corso: 'Corsi',
        desert: 'Esperienze Deserto',
        rally: 'Rally',
        from: 'Dal',
        to: 'al',
        price: 'Prezzo',
        priceFrom: 'A partire da',
        details: 'Dettagli',
        register: 'Iscriviti',
        spots: 'Posti disponibili',
        soldOut: 'Sold Out',
        moreInfo: 'Maggiori informazioni',
        viewAll: 'Vedi tutti gli eventi',
        noEvents: 'Nessun evento disponibile',
        groupedBy: 'raggruppati per paese',
        dates: 'Date disponibili',
        duration: 'Durata',
        days: 'giorni',
        difficulty: 'Difficoltà',
        included: 'Cosa include',
        notIncluded: 'Non incluso',
        itinerary: 'Itinerario',
        requirements: 'Requisiti',
        bookNow: 'Prenota ora',
        askInfo: 'Richiedi informazioni',
        shareEvent: 'Condividi evento',
        similarEvents: 'Eventi simili',
        deposit: 'Acconto',
        balance: 'Saldo',
        ownBike: 'Moto Propria',
        rentalBike: 'Moto a Noleggio',
        singleRoom: 'Supplemento Singola'
      },
      registration: {
        title: 'Iscrizione Evento',
        personalInfo: 'Informazioni Personali',
        name: 'Nome',
        surname: 'Cognome',
        birthDate: 'Data di Nascita',
        birthPlace: 'Luogo di Nascita',
        fiscalCode: 'Codice Fiscale',
        address: 'Indirizzo',
        city: 'Città',
        cap: 'CAP',
        email: 'Email',
        passport: 'Numero Passaporto',
        whatsapp: 'WhatsApp',
        phone: 'Telefono',
        nickname: 'Nickname',
        motorcycle: 'Scelta Moto',
        motorcycleLabel: 'Moto da noleggiare o propria',
        motorcycleBrand: 'Marca Moto',
        motorcycleModel: 'Modello Moto',
        motorcycleCC: 'Cilindrata',
        room: 'Sistemazione',
        roomSingle: 'Singola',
        roomDouble: 'Doppia',
        roomTriple: 'Tripla',
        roommate: 'Compagno di stanza',
        food: 'Intolleranze Alimentari',
        foodNone: 'Nessuna',
        foodVeg: 'Vegetariano',
        foodVegan: 'Vegano',
        foodGluten: 'Senza Glutine',
        foodOther: 'Altro',
        foodOtherPlaceholder: 'Specifica intolleranza/allergia',
        allergies: 'Allergie',
        allergiesPlaceholder: 'Specifica eventuali allergie',
        tshirt: 'Taglia Maglietta',
        payment: 'Pagamento',
        paymentInfo: 'Deposito all\'iscrizione - Saldo 15 giorni prima della partenza',
        paymentMethods: 'Metodi di pagamento',
        iban: 'IBAN per bonifico',
        sumup: 'Paga con carta',
        payNow: 'Paga ora',
        submit: 'Invia Iscrizione',
        success: 'Iscrizione inviata con successo!',
        error: 'Errore durante l\'iscrizione',
        terms: 'Accetto i termini e condizioni',
        privacy: 'Accetto la privacy policy',
        required: 'Campo obbligatorio',
        invalidEmail: 'Email non valida',
        thankYou: 'Grazie per la tua iscrizione!',
        confirmEmail: 'Riceverai una email di conferma'
      },
      gallery: {
        title: 'Galleria',
        subtitle: 'Rivivi le emozioni delle nostre avventure',
        photos: 'Foto',
        videos: 'Video',
        events: 'Eventi',
        noPhotos: 'Nessuna foto disponibile',
        noVideos: 'Nessun video disponibile',
        viewAll: 'Vedi tutte',
        loadMore: 'Carica altre',
        backToAll: 'Torna a tutte le gallerie',
        noGallery: 'Nessuna galleria per questo evento',
        comingSoon: 'Le foto e i video saranno disponibili presto'
      },
      about: {
        title: 'Chi Siamo',
        subtitle: 'La storia di Offroad Italia',
        experience: 'Anni di Esperienza',
        participants: 'Partecipanti',
        countries: 'Paesi Visitati',
        reviews: 'Recensioni 5 Stelle',
        mission: 'La nostra missione',
        team: 'Il nostro team',
        history: 'La nostra storia',
        values: 'I nostri valori',
        partners: 'I nostri partner'
      },
      contact: {
        title: 'Contatti',
        subtitle: 'Scrivici per qualsiasi informazione',
        name: 'Nome',
        email: 'Email',
        phone: 'Telefono',
        subject: 'Oggetto',
        message: 'Messaggio',
        send: 'Invia',
        sending: 'Invio in corso...',
        success: 'Messaggio inviato con successo!',
        error: 'Errore nell\'invio del messaggio',
        whatsapp: 'Contattaci su WhatsApp',
        address: 'Indirizzo',
        hours: 'Orari',
        followUs: 'Seguici sui social'
      },
      reviews: {
        title: 'Cosa Dicono di Noi',
        subtitle: 'Oltre 200 recensioni 5 stelle su Google',
        readMore: 'Leggi altre recensioni',
        writeReview: 'Lascia una recensione'
      },
      footer: {
        followUs: 'Seguici',
        rights: 'Tutti i diritti riservati',
        privacy: 'Privacy Policy',
        cookies: 'Cookie Policy',
        terms: 'Termini e Condizioni',
        company: 'Azienda',
        support: 'Supporto',
        quickLinks: 'Link Rapidi'
      },
      common: {
        loading: 'Caricamento...',
        error: 'Si è verificato un errore',
        retry: 'Riprova',
        back: 'Indietro',
        next: 'Avanti',
        previous: 'Precedente',
        close: 'Chiudi',
        save: 'Salva',
        cancel: 'Annulla',
        delete: 'Elimina',
        edit: 'Modifica',
        view: 'Visualizza',
        search: 'Cerca',
        filter: 'Filtra',
        sort: 'Ordina',
        share: 'Condividi',
        download: 'Scarica',
        upload: 'Carica',
        yes: 'Sì',
        no: 'No',
        or: 'oppure',
        and: 'e',
        from: 'da',
        to: 'a',
        more: 'Altro',
        less: 'Meno',
        showMore: 'Mostra di più',
        showLess: 'Mostra meno',
        seeAll: 'Vedi tutto',
        readMore: 'Leggi di più'
      },
      newsletter: {
        title: 'Iscriviti alla Newsletter',
        subtitle: 'Ricevi aggiornamenti sui prossimi eventi',
        placeholder: 'La tua email',
        subscribe: 'Iscriviti',
        success: 'Iscrizione completata!',
        error: 'Errore durante l\'iscrizione'
      },
      corso: {
        title: 'Corso OsmAnd',
        subtitle: 'Navigazione Professionale per Enduro',
        slideOf: 'Slide {current} di {total}',
        autoplay: 'Auto-play',
        pause: 'Pausa',
        prevSlide: 'Slide precedente',
        nextSlide: 'Slide successiva',
        notAvailable: 'Corso non disponibile',
        notConfigured: 'Le slide del corso non sono ancora state configurate'
      },
      admin: {
        login: {
          title: 'Accesso Area Riservata',
          subtitle: 'Inserisci la password per accedere',
          password: 'Password',
          placeholder: 'Inserisci la password',
          submit: 'Accedi',
          loading: 'Accesso in corso...',
          error: 'Password errata!',
          connectionError: 'Errore di connessione. Riprova.',
          forgotPassword: 'Password dimenticata? Contatta l\'amministratore',
          accessTypes: 'Tipi di accesso disponibili:',
          adminAccess: 'Admin: Accesso completo',
          techAccess: 'Tecnico: Gallerie & Stats'
        },
        dashboard: {
          title: 'Dashboard Admin',
          welcome: 'Benvenuto',
          manageEvents: 'Gestione Eventi',
          createEvent: 'Nuovo Evento',
          bookings: 'Prenotazioni',
          payments: 'Pagamenti',
          galleries: 'Gallerie',
          media: 'Media',
          countries: 'Paesi',
          statistics: 'Statistiche',
          analytics: 'Analytics',
          course: 'Corso OsmAnd',
          logout: 'Esci',
          confirmDelete: 'Sei sicuro di voler eliminare',
          deleteSuccess: 'Evento eliminato con successo!',
          deleteError: 'Errore durante l\'eliminazione',
          accessRequired: 'Accesso Richiesto',
          loginRequired: 'Devi effettuare il login per accedere a questa pagina.',
          goToLogin: 'Vai al Login',
          topViewed: 'Eventi Più Visti',
          views: 'visualizzazioni',
          noViews: 'Nessuna visualizzazione registrata'
        },
        statistics: {
          title: 'Statistiche',
          overview: 'Panoramica',
          totalEvents: 'Eventi Totali',
          totalBookings: 'Prenotazioni Totali',
          totalRevenue: 'Ricavi Totali',
          avgPerEvent: 'Media per Evento',
          recentBookings: 'Prenotazioni Recenti',
          popularEvents: 'Eventi Popolari',
          noData: 'Nessun dato disponibile'
        },
        bookings: {
          title: 'Prenotazioni',
          export: 'Esporta CSV',
          search: 'Cerca prenotazione...',
          filterByEvent: 'Filtra per evento',
          allEvents: 'Tutti gli eventi',
          noBookings: 'Nessuna prenotazione trovata',
          participant: 'Partecipante',
          event: 'Evento',
          date: 'Data',
          status: 'Stato',
          amount: 'Importo',
          actions: 'Azioni'
        },
        common: {
          save: 'Salva',
          cancel: 'Annulla',
          delete: 'Elimina',
          edit: 'Modifica',
          create: 'Crea',
          update: 'Aggiorna',
          loading: 'Caricamento...',
          error: 'Errore',
          success: 'Successo',
          confirm: 'Conferma',
          back: 'Indietro',
          actions: 'Azioni'
        }
      }
    }
  },
  en: {
    translation: {
      nav: {
        home: 'Home',
        events: 'Events',
        gallery: 'Gallery',
        about: 'About Us',
        contact: 'Contact',
        admin: 'Admin',
        corsoOsmand: 'OsmAnd Course'
      },
      hero: {
        title: 'Live the Offroad Adventure',
        subtitle: 'SINCE 2011 WE ORGANIZE OFFROAD TOURS IN EUROPE, AFRICA AND SOUTH AMERICA',
        cta: 'Discover Events'
      },
      events: {
        title: 'Events',
        upcoming: 'Upcoming Events',
        filter: 'Filter by type',
        all: 'All',
        enduring: 'Enduring',
        tour: 'Tours',
        corso: 'Courses',
        desert: 'Desert Experiences',
        rally: 'Rally',
        from: 'From',
        to: 'to',
        price: 'Price',
        priceFrom: 'Starting from',
        details: 'Details',
        register: 'Register',
        spots: 'Available spots',
        soldOut: 'Sold Out',
        moreInfo: 'More information',
        viewAll: 'View all events',
        noEvents: 'No events available',
        groupedBy: 'grouped by country',
        dates: 'Available dates',
        duration: 'Duration',
        days: 'days',
        difficulty: 'Difficulty',
        included: 'What\'s included',
        notIncluded: 'Not included',
        itinerary: 'Itinerary',
        requirements: 'Requirements',
        bookNow: 'Book now',
        askInfo: 'Request information',
        shareEvent: 'Share event',
        similarEvents: 'Similar events',
        deposit: 'Deposit',
        balance: 'Balance',
        ownBike: 'Own Bike',
        rentalBike: 'Rental Bike',
        singleRoom: 'Single Room Supplement'
      },
      registration: {
        title: 'Event Registration',
        personalInfo: 'Personal Information',
        name: 'Name',
        surname: 'Surname',
        birthDate: 'Birth Date',
        birthPlace: 'Birth Place',
        fiscalCode: 'Tax Code',
        address: 'Address',
        city: 'City',
        cap: 'Postal Code',
        email: 'Email',
        passport: 'Passport Number',
        whatsapp: 'WhatsApp',
        phone: 'Phone',
        nickname: 'Nickname',
        motorcycle: 'Motorcycle Choice',
        motorcycleLabel: 'Rent or own motorcycle',
        motorcycleBrand: 'Motorcycle Brand',
        motorcycleModel: 'Motorcycle Model',
        motorcycleCC: 'Engine Size',
        room: 'Accommodation',
        roomSingle: 'Single',
        roomDouble: 'Double',
        roomTriple: 'Triple',
        roommate: 'Roommate',
        food: 'Food Intolerance',
        foodNone: 'None',
        foodVeg: 'Vegetarian',
        foodVegan: 'Vegan',
        foodGluten: 'Gluten Free',
        foodOther: 'Other',
        foodOtherPlaceholder: 'Specify intolerance/allergy',
        allergies: 'Allergies',
        allergiesPlaceholder: 'Specify any allergies',
        tshirt: 'T-Shirt Size',
        payment: 'Payment',
        paymentInfo: 'Deposit on registration - Balance 15 days before departure',
        paymentMethods: 'Payment methods',
        iban: 'IBAN for bank transfer',
        sumup: 'Pay with card',
        payNow: 'Pay now',
        submit: 'Submit Registration',
        success: 'Registration submitted successfully!',
        error: 'Error during registration',
        terms: 'I accept the terms and conditions',
        privacy: 'I accept the privacy policy',
        required: 'Required field',
        invalidEmail: 'Invalid email',
        thankYou: 'Thank you for your registration!',
        confirmEmail: 'You will receive a confirmation email'
      },
      gallery: {
        title: 'Gallery',
        subtitle: 'Relive the emotions of our adventures',
        photos: 'Photos',
        videos: 'Videos',
        events: 'Events',
        noPhotos: 'No photos available',
        noVideos: 'No videos available',
        viewAll: 'View all',
        loadMore: 'Load more',
        backToAll: 'Back to all galleries',
        noGallery: 'No gallery for this event',
        comingSoon: 'Photos and videos coming soon'
      },
      about: {
        title: 'About Us',
        subtitle: 'The story of Offroad Italia',
        experience: 'Years of Experience',
        participants: 'Participants',
        countries: 'Countries Visited',
        reviews: '5-Star Reviews',
        mission: 'Our mission',
        team: 'Our team',
        history: 'Our history',
        values: 'Our values',
        partners: 'Our partners'
      },
      contact: {
        title: 'Contact',
        subtitle: 'Write to us for any information',
        name: 'Name',
        email: 'Email',
        phone: 'Phone',
        subject: 'Subject',
        message: 'Message',
        send: 'Send',
        sending: 'Sending...',
        success: 'Message sent successfully!',
        error: 'Error sending message',
        whatsapp: 'Contact us on WhatsApp',
        address: 'Address',
        hours: 'Hours',
        followUs: 'Follow us on social media'
      },
      reviews: {
        title: 'What They Say About Us',
        subtitle: 'Over 200 5-star reviews on Google',
        readMore: 'Read more reviews',
        writeReview: 'Write a review'
      },
      footer: {
        followUs: 'Follow Us',
        rights: 'All rights reserved',
        privacy: 'Privacy Policy',
        cookies: 'Cookie Policy',
        terms: 'Terms and Conditions',
        company: 'Company',
        support: 'Support',
        quickLinks: 'Quick Links'
      },
      common: {
        loading: 'Loading...',
        error: 'An error occurred',
        retry: 'Retry',
        back: 'Back',
        next: 'Next',
        previous: 'Previous',
        close: 'Close',
        save: 'Save',
        cancel: 'Cancel',
        delete: 'Delete',
        edit: 'Edit',
        view: 'View',
        search: 'Search',
        filter: 'Filter',
        sort: 'Sort',
        share: 'Share',
        download: 'Download',
        upload: 'Upload',
        yes: 'Yes',
        no: 'No',
        or: 'or',
        and: 'and',
        from: 'from',
        to: 'to',
        more: 'More',
        less: 'Less',
        showMore: 'Show more',
        showLess: 'Show less',
        seeAll: 'See all',
        readMore: 'Read more'
      },
      newsletter: {
        title: 'Subscribe to Newsletter',
        subtitle: 'Get updates on upcoming events',
        placeholder: 'Your email',
        subscribe: 'Subscribe',
        success: 'Subscription complete!',
        error: 'Error during subscription'
      },
      corso: {
        title: 'OsmAnd Course',
        subtitle: 'Professional Navigation for Enduro',
        slideOf: 'Slide {current} of {total}',
        autoplay: 'Auto-play',
        pause: 'Pause',
        prevSlide: 'Previous slide',
        nextSlide: 'Next slide',
        notAvailable: 'Course not available',
        notConfigured: 'Course slides have not been configured yet'
      },
      admin: {
        login: {
          title: 'Reserved Area Access',
          subtitle: 'Enter your password to access',
          password: 'Password',
          placeholder: 'Enter password',
          submit: 'Login',
          loading: 'Logging in...',
          error: 'Wrong password!',
          connectionError: 'Connection error. Please retry.',
          forgotPassword: 'Forgot password? Contact the administrator',
          accessTypes: 'Available access types:',
          adminAccess: 'Admin: Full access',
          techAccess: 'Technician: Galleries & Stats'
        },
        dashboard: {
          title: 'Admin Dashboard',
          welcome: 'Welcome',
          manageEvents: 'Manage Events',
          createEvent: 'New Event',
          bookings: 'Bookings',
          payments: 'Payments',
          galleries: 'Galleries',
          media: 'Media',
          countries: 'Countries',
          statistics: 'Statistics',
          analytics: 'Analytics',
          course: 'OsmAnd Course',
          logout: 'Logout',
          confirmDelete: 'Are you sure you want to delete',
          deleteSuccess: 'Event deleted successfully!',
          deleteError: 'Error deleting event',
          accessRequired: 'Access Required',
          loginRequired: 'You need to login to access this page.',
          goToLogin: 'Go to Login',
          topViewed: 'Most Viewed Events',
          views: 'views',
          noViews: 'No views recorded'
        },
        statistics: {
          title: 'Statistics',
          overview: 'Overview',
          totalEvents: 'Total Events',
          totalBookings: 'Total Bookings',
          totalRevenue: 'Total Revenue',
          avgPerEvent: 'Average per Event',
          recentBookings: 'Recent Bookings',
          popularEvents: 'Popular Events',
          noData: 'No data available'
        },
        bookings: {
          title: 'Bookings',
          export: 'Export CSV',
          search: 'Search booking...',
          filterByEvent: 'Filter by event',
          allEvents: 'All events',
          noBookings: 'No bookings found',
          participant: 'Participant',
          event: 'Event',
          date: 'Date',
          status: 'Status',
          amount: 'Amount',
          actions: 'Actions'
        },
        common: {
          save: 'Save',
          cancel: 'Cancel',
          delete: 'Delete',
          edit: 'Edit',
          create: 'Create',
          update: 'Update',
          loading: 'Loading...',
          error: 'Error',
          success: 'Success',
          confirm: 'Confirm',
          back: 'Back',
          actions: 'Actions'
        }
      }
    }
  },
  de: {
    translation: {
      nav: {
        home: 'Home',
        events: 'Veranstaltungen',
        gallery: 'Galerie',
        about: 'Über Uns',
        contact: 'Kontakt',
        admin: 'Admin',
        corsoOsmand: 'OsmAnd Kurs'
      },
      hero: {
        title: 'Erlebe das Offroad-Abenteuer',
        subtitle: 'SEIT 2011 ORGANISIEREN WIR OFFROAD-TOUREN IN EUROPA, AFRIKA UND SÜDAMERIKA',
        cta: 'Events Entdecken'
      },
      events: {
        title: 'Events',
        upcoming: 'Kommende Events',
        filter: 'Nach Typ filtern',
        all: 'Alle',
        enduring: 'Enduring',
        tour: 'Touren',
        corso: 'Kurse',
        desert: 'Wüstenerlebnisse',
        rally: 'Rally',
        from: 'Von',
        to: 'bis',
        price: 'Preis',
        priceFrom: 'Ab',
        details: 'Details',
        register: 'Anmelden',
        spots: 'Verfügbare Plätze',
        soldOut: 'Ausverkauft',
        moreInfo: 'Mehr Informationen',
        viewAll: 'Alle Events anzeigen',
        noEvents: 'Keine Events verfügbar',
        groupedBy: 'gruppiert nach Land',
        dates: 'Verfügbare Termine',
        duration: 'Dauer',
        days: 'Tage',
        difficulty: 'Schwierigkeit',
        included: 'Inklusivleistungen',
        notIncluded: 'Nicht enthalten',
        itinerary: 'Reiseroute',
        requirements: 'Voraussetzungen',
        bookNow: 'Jetzt buchen',
        askInfo: 'Informationen anfordern',
        shareEvent: 'Event teilen',
        similarEvents: 'Ähnliche Events',
        deposit: 'Anzahlung',
        balance: 'Restbetrag',
        ownBike: 'Eigenes Motorrad',
        rentalBike: 'Mietmotorrad',
        singleRoom: 'Einzelzimmerzuschlag'
      },
      registration: {
        title: 'Event-Anmeldung',
        personalInfo: 'Persönliche Daten',
        name: 'Vorname',
        surname: 'Nachname',
        birthDate: 'Geburtsdatum',
        birthPlace: 'Geburtsort',
        fiscalCode: 'Steuernummer',
        address: 'Adresse',
        city: 'Stadt',
        cap: 'PLZ',
        email: 'E-Mail',
        passport: 'Passnummer',
        whatsapp: 'WhatsApp',
        phone: 'Telefon',
        nickname: 'Spitzname',
        motorcycle: 'Motorradwahl',
        motorcycleLabel: 'Mieten oder eigenes Motorrad',
        motorcycleBrand: 'Motorradmarke',
        motorcycleModel: 'Motorradmodell',
        motorcycleCC: 'Hubraum',
        room: 'Unterkunft',
        roomSingle: 'Einzelzimmer',
        roomDouble: 'Doppelzimmer',
        roomTriple: 'Dreibettzimmer',
        roommate: 'Zimmergenosse',
        food: 'Lebensmittelunverträglichkeit',
        foodNone: 'Keine',
        foodVeg: 'Vegetarisch',
        foodVegan: 'Vegan',
        foodGluten: 'Glutenfrei',
        foodOther: 'Andere',
        foodOtherPlaceholder: 'Unverträglichkeit angeben',
        allergies: 'Allergien',
        allergiesPlaceholder: 'Eventuelle Allergien angeben',
        tshirt: 'T-Shirt Größe',
        payment: 'Zahlung',
        paymentInfo: 'Anzahlung bei Anmeldung - Restbetrag 15 Tage vor Abreise',
        paymentMethods: 'Zahlungsmethoden',
        iban: 'IBAN für Überweisung',
        sumup: 'Mit Karte bezahlen',
        payNow: 'Jetzt bezahlen',
        submit: 'Anmeldung absenden',
        success: 'Anmeldung erfolgreich!',
        error: 'Fehler bei der Anmeldung',
        terms: 'Ich akzeptiere die AGB',
        privacy: 'Ich akzeptiere die Datenschutzerklärung',
        required: 'Pflichtfeld',
        invalidEmail: 'Ungültige E-Mail',
        thankYou: 'Vielen Dank für Ihre Anmeldung!',
        confirmEmail: 'Sie erhalten eine Bestätigungsmail'
      },
      gallery: {
        title: 'Galerie',
        subtitle: 'Erleben Sie unsere Abenteuer in Bildern',
        photos: 'Fotos',
        videos: 'Videos',
        events: 'Events',
        noPhotos: 'Keine Fotos verfügbar',
        noVideos: 'Keine Videos verfügbar',
        viewAll: 'Alle ansehen',
        loadMore: 'Mehr laden',
        backToAll: 'Zurück zu allen Galerien',
        noGallery: 'Keine Galerie für dieses Event',
        comingSoon: 'Fotos und Videos folgen'
      },
      about: {
        title: 'Über Uns',
        subtitle: 'Die Geschichte von Offroad Italia',
        experience: 'Jahre Erfahrung',
        participants: 'Teilnehmer',
        countries: 'Besuchte Länder',
        reviews: '5-Sterne Bewertungen',
        mission: 'Unsere Mission',
        team: 'Unser Team',
        history: 'Unsere Geschichte',
        values: 'Unsere Werte',
        partners: 'Unsere Partner'
      },
      contact: {
        title: 'Kontakt',
        subtitle: 'Schreiben Sie uns für Informationen',
        name: 'Name',
        email: 'E-Mail',
        phone: 'Telefon',
        subject: 'Betreff',
        message: 'Nachricht',
        send: 'Senden',
        sending: 'Wird gesendet...',
        success: 'Nachricht erfolgreich gesendet!',
        error: 'Fehler beim Senden',
        whatsapp: 'Kontaktieren Sie uns auf WhatsApp',
        address: 'Adresse',
        hours: 'Öffnungszeiten',
        followUs: 'Folgen Sie uns'
      },
      reviews: {
        title: 'Das sagen unsere Kunden',
        subtitle: 'Über 200 5-Sterne Bewertungen auf Google',
        readMore: 'Mehr Bewertungen lesen',
        writeReview: 'Bewertung schreiben'
      },
      footer: {
        followUs: 'Folgen Sie uns',
        rights: 'Alle Rechte vorbehalten',
        privacy: 'Datenschutz',
        cookies: 'Cookie-Richtlinie',
        terms: 'AGB',
        company: 'Unternehmen',
        support: 'Support',
        quickLinks: 'Schnelllinks'
      },
      common: {
        loading: 'Wird geladen...',
        error: 'Ein Fehler ist aufgetreten',
        retry: 'Erneut versuchen',
        back: 'Zurück',
        next: 'Weiter',
        previous: 'Zurück',
        close: 'Schließen',
        save: 'Speichern',
        cancel: 'Abbrechen',
        delete: 'Löschen',
        edit: 'Bearbeiten',
        view: 'Ansehen',
        search: 'Suchen',
        filter: 'Filtern',
        sort: 'Sortieren',
        share: 'Teilen',
        download: 'Herunterladen',
        upload: 'Hochladen',
        yes: 'Ja',
        no: 'Nein',
        or: 'oder',
        and: 'und',
        from: 'von',
        to: 'bis',
        more: 'Mehr',
        less: 'Weniger',
        showMore: 'Mehr anzeigen',
        showLess: 'Weniger anzeigen',
        seeAll: 'Alle anzeigen',
        readMore: 'Mehr lesen'
      },
      newsletter: {
        title: 'Newsletter abonnieren',
        subtitle: 'Updates zu kommenden Events erhalten',
        placeholder: 'Ihre E-Mail',
        subscribe: 'Abonnieren',
        success: 'Erfolgreich abonniert!',
        error: 'Fehler beim Abonnieren'
      },
      corso: {
        title: 'OsmAnd Kurs',
        subtitle: 'Professionelle Navigation für Enduro',
        slideOf: 'Folie {current} von {total}',
        autoplay: 'Automatisch',
        pause: 'Pause',
        prevSlide: 'Vorherige Folie',
        nextSlide: 'Nächste Folie',
        notAvailable: 'Kurs nicht verfügbar',
        notConfigured: 'Kursfolien wurden noch nicht konfiguriert'
      },
      admin: {
        login: {
          title: 'Geschützter Bereich',
          subtitle: 'Geben Sie Ihr Passwort ein',
          password: 'Passwort',
          placeholder: 'Passwort eingeben',
          submit: 'Anmelden',
          loading: 'Anmeldung...',
          error: 'Falsches Passwort!',
          connectionError: 'Verbindungsfehler. Bitte erneut versuchen.',
          forgotPassword: 'Passwort vergessen? Kontaktieren Sie den Administrator',
          accessTypes: 'Verfügbare Zugriffstypen:',
          adminAccess: 'Admin: Vollzugriff',
          techAccess: 'Techniker: Galerien & Statistiken'
        },
        dashboard: {
          title: 'Admin Dashboard',
          welcome: 'Willkommen',
          manageEvents: 'Events verwalten',
          createEvent: 'Neues Event',
          bookings: 'Buchungen',
          payments: 'Zahlungen',
          galleries: 'Galerien',
          media: 'Medien',
          countries: 'Länder',
          statistics: 'Statistiken',
          analytics: 'Analytics',
          course: 'OsmAnd Kurs',
          logout: 'Abmelden',
          confirmDelete: 'Sind Sie sicher, dass Sie löschen möchten',
          deleteSuccess: 'Event erfolgreich gelöscht!',
          deleteError: 'Fehler beim Löschen',
          accessRequired: 'Zugang erforderlich',
          loginRequired: 'Sie müssen sich anmelden, um auf diese Seite zuzugreifen.',
          goToLogin: 'Zur Anmeldung',
          topViewed: 'Meistgesehene Events',
          views: 'Aufrufe',
          noViews: 'Keine Aufrufe registriert'
        },
        statistics: {
          title: 'Statistiken',
          overview: 'Übersicht',
          totalEvents: 'Gesamte Events',
          totalBookings: 'Gesamte Buchungen',
          totalRevenue: 'Gesamtumsatz',
          avgPerEvent: 'Durchschnitt pro Event',
          recentBookings: 'Letzte Buchungen',
          popularEvents: 'Beliebte Events',
          noData: 'Keine Daten verfügbar'
        },
        bookings: {
          title: 'Buchungen',
          export: 'CSV exportieren',
          search: 'Buchung suchen...',
          filterByEvent: 'Nach Event filtern',
          allEvents: 'Alle Events',
          noBookings: 'Keine Buchungen gefunden',
          participant: 'Teilnehmer',
          event: 'Event',
          date: 'Datum',
          status: 'Status',
          amount: 'Betrag',
          actions: 'Aktionen'
        },
        common: {
          save: 'Speichern',
          cancel: 'Abbrechen',
          delete: 'Löschen',
          edit: 'Bearbeiten',
          create: 'Erstellen',
          update: 'Aktualisieren',
          loading: 'Wird geladen...',
          error: 'Fehler',
          success: 'Erfolg',
          confirm: 'Bestätigen',
          back: 'Zurück',
          actions: 'Aktionen'
        }
      }
    }
  },
  fr: {
    translation: {
      nav: {
        home: 'Accueil',
        events: 'Événements',
        gallery: 'Galerie',
        about: 'À Propos',
        contact: 'Contact',
        admin: 'Admin',
        corsoOsmand: 'Cours OsmAnd'
      },
      hero: {
        title: 'Vivez l\'Aventure Offroad',
        subtitle: 'DEPUIS 2011, NOUS ORGANISONS DES TOURS OFFROAD EN EUROPE, AFRIQUE ET AMÉRIQUE DU SUD',
        cta: 'Découvrir les Événements'
      },
      events: {
        title: 'Événements',
        upcoming: 'Événements à Venir',
        filter: 'Filtrer par type',
        all: 'Tous',
        enduring: 'Enduring',
        tour: 'Tours',
        corso: 'Cours',
        desert: 'Expériences Désert',
        rally: 'Rallye',
        from: 'Du',
        to: 'au',
        price: 'Prix',
        priceFrom: 'À partir de',
        details: 'Détails',
        register: 'S\'inscrire',
        spots: 'Places disponibles',
        soldOut: 'Complet',
        moreInfo: 'Plus d\'informations',
        viewAll: 'Voir tous les événements',
        noEvents: 'Aucun événement disponible',
        groupedBy: 'groupés par pays',
        dates: 'Dates disponibles',
        duration: 'Durée',
        days: 'jours',
        difficulty: 'Difficulté',
        included: 'Ce qui est inclus',
        notIncluded: 'Non inclus',
        itinerary: 'Itinéraire',
        requirements: 'Prérequis',
        bookNow: 'Réserver',
        askInfo: 'Demander des informations',
        shareEvent: 'Partager l\'événement',
        similarEvents: 'Événements similaires',
        deposit: 'Acompte',
        balance: 'Solde',
        ownBike: 'Moto Personnelle',
        rentalBike: 'Moto de Location',
        singleRoom: 'Supplément Chambre Simple'
      },
      registration: {
        title: 'Inscription à l\'Événement',
        personalInfo: 'Informations Personnelles',
        name: 'Prénom',
        surname: 'Nom',
        birthDate: 'Date de Naissance',
        birthPlace: 'Lieu de Naissance',
        fiscalCode: 'Numéro Fiscal',
        address: 'Adresse',
        city: 'Ville',
        cap: 'Code Postal',
        email: 'Email',
        passport: 'Numéro de Passeport',
        whatsapp: 'WhatsApp',
        phone: 'Téléphone',
        nickname: 'Surnom',
        motorcycle: 'Choix de Moto',
        motorcycleLabel: 'Location ou propre moto',
        motorcycleBrand: 'Marque de Moto',
        motorcycleModel: 'Modèle de Moto',
        motorcycleCC: 'Cylindrée',
        room: 'Hébergement',
        roomSingle: 'Simple',
        roomDouble: 'Double',
        roomTriple: 'Triple',
        roommate: 'Colocataire',
        food: 'Intolérance Alimentaire',
        foodNone: 'Aucune',
        foodVeg: 'Végétarien',
        foodVegan: 'Végan',
        foodGluten: 'Sans Gluten',
        foodOther: 'Autre',
        foodOtherPlaceholder: 'Préciser l\'intolérance/allergie',
        allergies: 'Allergies',
        allergiesPlaceholder: 'Préciser les allergies éventuelles',
        tshirt: 'Taille T-Shirt',
        payment: 'Paiement',
        paymentInfo: 'Acompte à l\'inscription - Solde 15 jours avant le départ',
        paymentMethods: 'Modes de paiement',
        iban: 'IBAN pour virement',
        sumup: 'Payer par carte',
        payNow: 'Payer maintenant',
        submit: 'Envoyer l\'Inscription',
        success: 'Inscription envoyée avec succès!',
        error: 'Erreur lors de l\'inscription',
        terms: 'J\'accepte les conditions générales',
        privacy: 'J\'accepte la politique de confidentialité',
        required: 'Champ obligatoire',
        invalidEmail: 'Email invalide',
        thankYou: 'Merci pour votre inscription!',
        confirmEmail: 'Vous recevrez un email de confirmation'
      },
      gallery: {
        title: 'Galerie',
        subtitle: 'Revivez les émotions de nos aventures',
        photos: 'Photos',
        videos: 'Vidéos',
        events: 'Événements',
        noPhotos: 'Aucune photo disponible',
        noVideos: 'Aucune vidéo disponible',
        viewAll: 'Voir tout',
        loadMore: 'Charger plus',
        backToAll: 'Retour à toutes les galeries',
        noGallery: 'Pas de galerie pour cet événement',
        comingSoon: 'Photos et vidéos bientôt disponibles'
      },
      about: {
        title: 'À Propos',
        subtitle: 'L\'histoire d\'Offroad Italia',
        experience: 'Années d\'Expérience',
        participants: 'Participants',
        countries: 'Pays Visités',
        reviews: 'Avis 5 Étoiles',
        mission: 'Notre mission',
        team: 'Notre équipe',
        history: 'Notre histoire',
        values: 'Nos valeurs',
        partners: 'Nos partenaires'
      },
      contact: {
        title: 'Contact',
        subtitle: 'Écrivez-nous pour toute information',
        name: 'Nom',
        email: 'Email',
        phone: 'Téléphone',
        subject: 'Sujet',
        message: 'Message',
        send: 'Envoyer',
        sending: 'Envoi en cours...',
        success: 'Message envoyé avec succès!',
        error: 'Erreur lors de l\'envoi',
        whatsapp: 'Contactez-nous sur WhatsApp',
        address: 'Adresse',
        hours: 'Horaires',
        followUs: 'Suivez-nous sur les réseaux'
      },
      reviews: {
        title: 'Ce Qu\'ils Disent de Nous',
        subtitle: 'Plus de 200 avis 5 étoiles sur Google',
        readMore: 'Lire plus d\'avis',
        writeReview: 'Laisser un avis'
      },
      footer: {
        followUs: 'Suivez-nous',
        rights: 'Tous droits réservés',
        privacy: 'Politique de Confidentialité',
        cookies: 'Politique de Cookies',
        terms: 'Conditions Générales',
        company: 'Entreprise',
        support: 'Support',
        quickLinks: 'Liens Rapides'
      },
      common: {
        loading: 'Chargement...',
        error: 'Une erreur est survenue',
        retry: 'Réessayer',
        back: 'Retour',
        next: 'Suivant',
        previous: 'Précédent',
        close: 'Fermer',
        save: 'Enregistrer',
        cancel: 'Annuler',
        delete: 'Supprimer',
        edit: 'Modifier',
        view: 'Voir',
        search: 'Rechercher',
        filter: 'Filtrer',
        sort: 'Trier',
        share: 'Partager',
        download: 'Télécharger',
        upload: 'Charger',
        yes: 'Oui',
        no: 'Non',
        or: 'ou',
        and: 'et',
        from: 'de',
        to: 'à',
        more: 'Plus',
        less: 'Moins',
        showMore: 'Voir plus',
        showLess: 'Voir moins',
        seeAll: 'Voir tout',
        readMore: 'Lire la suite'
      },
      newsletter: {
        title: 'Inscrivez-vous à la Newsletter',
        subtitle: 'Recevez les actualités des prochains événements',
        placeholder: 'Votre email',
        subscribe: 'S\'inscrire',
        success: 'Inscription réussie!',
        error: 'Erreur lors de l\'inscription'
      },
      corso: {
        title: 'Cours OsmAnd',
        subtitle: 'Navigation Professionnelle pour Enduro',
        slideOf: 'Diapo {current} sur {total}',
        autoplay: 'Lecture auto',
        pause: 'Pause',
        prevSlide: 'Diapo précédente',
        nextSlide: 'Diapo suivante',
        notAvailable: 'Cours non disponible',
        notConfigured: 'Les diapositives du cours n\'ont pas encore été configurées'
      },
      admin: {
        login: {
          title: 'Accès Zone Réservée',
          subtitle: 'Entrez votre mot de passe',
          password: 'Mot de passe',
          placeholder: 'Entrez le mot de passe',
          submit: 'Connexion',
          loading: 'Connexion...',
          error: 'Mot de passe incorrect!',
          connectionError: 'Erreur de connexion. Veuillez réessayer.',
          forgotPassword: 'Mot de passe oublié? Contactez l\'administrateur',
          accessTypes: 'Types d\'accès disponibles:',
          adminAccess: 'Admin: Accès complet',
          techAccess: 'Technicien: Galeries & Stats'
        },
        dashboard: {
          title: 'Tableau de bord Admin',
          welcome: 'Bienvenue',
          manageEvents: 'Gérer les événements',
          createEvent: 'Nouvel événement',
          bookings: 'Réservations',
          payments: 'Paiements',
          galleries: 'Galeries',
          media: 'Médias',
          countries: 'Pays',
          statistics: 'Statistiques',
          analytics: 'Analytics',
          course: 'Cours OsmAnd',
          logout: 'Déconnexion',
          confirmDelete: 'Êtes-vous sûr de vouloir supprimer',
          deleteSuccess: 'Événement supprimé avec succès!',
          deleteError: 'Erreur lors de la suppression',
          accessRequired: 'Accès requis',
          loginRequired: 'Vous devez vous connecter pour accéder à cette page.',
          goToLogin: 'Aller à la connexion',
          topViewed: 'Événements les plus vus',
          views: 'vues',
          noViews: 'Aucune vue enregistrée'
        },
        statistics: {
          title: 'Statistiques',
          overview: 'Aperçu',
          totalEvents: 'Total événements',
          totalBookings: 'Total réservations',
          totalRevenue: 'Revenu total',
          avgPerEvent: 'Moyenne par événement',
          recentBookings: 'Réservations récentes',
          popularEvents: 'Événements populaires',
          noData: 'Aucune donnée disponible'
        },
        bookings: {
          title: 'Réservations',
          export: 'Exporter CSV',
          search: 'Rechercher réservation...',
          filterByEvent: 'Filtrer par événement',
          allEvents: 'Tous les événements',
          noBookings: 'Aucune réservation trouvée',
          participant: 'Participant',
          event: 'Événement',
          date: 'Date',
          status: 'Statut',
          amount: 'Montant',
          actions: 'Actions'
        },
        common: {
          save: 'Enregistrer',
          cancel: 'Annuler',
          delete: 'Supprimer',
          edit: 'Modifier',
          create: 'Créer',
          update: 'Mettre à jour',
          loading: 'Chargement...',
          error: 'Erreur',
          success: 'Succès',
          confirm: 'Confirmer',
          back: 'Retour',
          actions: 'Actions'
        }
      }
    }
  },
  es: {
    translation: {
      nav: {
        home: 'Inicio',
        events: 'Eventos',
        gallery: 'Galería',
        about: 'Nosotros',
        contact: 'Contacto',
        admin: 'Admin',
        corsoOsmand: 'Curso OsmAnd'
      },
      hero: {
        title: 'Vive la Aventura Offroad',
        subtitle: 'DESDE 2011 ORGANIZAMOS TOURS OFFROAD EN EUROPA, ÁFRICA Y SUDAMÉRICA',
        cta: 'Descubre Eventos'
      },
      events: {
        title: 'Eventos',
        upcoming: 'Próximos Eventos',
        filter: 'Filtrar por tipo',
        all: 'Todos',
        enduring: 'Enduring',
        tour: 'Tours',
        corso: 'Cursos',
        desert: 'Experiencias Desierto',
        rally: 'Rally',
        from: 'Del',
        to: 'al',
        price: 'Precio',
        priceFrom: 'Desde',
        details: 'Detalles',
        register: 'Inscribirse',
        spots: 'Plazas disponibles',
        soldOut: 'Agotado',
        moreInfo: 'Más información',
        viewAll: 'Ver todos los eventos',
        noEvents: 'No hay eventos disponibles',
        groupedBy: 'agrupados por país',
        dates: 'Fechas disponibles',
        duration: 'Duración',
        days: 'días',
        difficulty: 'Dificultad',
        included: 'Qué incluye',
        notIncluded: 'No incluido',
        itinerary: 'Itinerario',
        requirements: 'Requisitos',
        bookNow: 'Reservar ahora',
        askInfo: 'Pedir información',
        shareEvent: 'Compartir evento',
        similarEvents: 'Eventos similares',
        deposit: 'Depósito',
        balance: 'Saldo',
        ownBike: 'Moto Propia',
        rentalBike: 'Moto de Alquiler',
        singleRoom: 'Suplemento Habitación Individual'
      },
      registration: {
        title: 'Inscripción al Evento',
        personalInfo: 'Información Personal',
        name: 'Nombre',
        surname: 'Apellido',
        birthDate: 'Fecha de Nacimiento',
        birthPlace: 'Lugar de Nacimiento',
        fiscalCode: 'NIF/CIF',
        address: 'Dirección',
        city: 'Ciudad',
        cap: 'Código Postal',
        email: 'Email',
        passport: 'Número de Pasaporte',
        whatsapp: 'WhatsApp',
        phone: 'Teléfono',
        nickname: 'Apodo',
        motorcycle: 'Elección de Moto',
        motorcycleLabel: 'Alquilar o moto propia',
        motorcycleBrand: 'Marca de Moto',
        motorcycleModel: 'Modelo de Moto',
        motorcycleCC: 'Cilindrada',
        room: 'Alojamiento',
        roomSingle: 'Individual',
        roomDouble: 'Doble',
        roomTriple: 'Triple',
        roommate: 'Compañero de habitación',
        food: 'Intolerancia Alimentaria',
        foodNone: 'Ninguna',
        foodVeg: 'Vegetariano',
        foodVegan: 'Vegano',
        foodGluten: 'Sin Gluten',
        foodOther: 'Otra',
        foodOtherPlaceholder: 'Especificar intolerancia/alergia',
        allergies: 'Alergias',
        allergiesPlaceholder: 'Especificar alergias',
        tshirt: 'Talla de Camiseta',
        payment: 'Pago',
        paymentInfo: 'Depósito en la inscripción - Saldo 15 días antes de la salida',
        paymentMethods: 'Métodos de pago',
        iban: 'IBAN para transferencia',
        sumup: 'Pagar con tarjeta',
        payNow: 'Pagar ahora',
        submit: 'Enviar Inscripción',
        success: '¡Inscripción enviada con éxito!',
        error: 'Error durante la inscripción',
        terms: 'Acepto los términos y condiciones',
        privacy: 'Acepto la política de privacidad',
        required: 'Campo obligatorio',
        invalidEmail: 'Email inválido',
        thankYou: '¡Gracias por tu inscripción!',
        confirmEmail: 'Recibirás un email de confirmación'
      },
      gallery: {
        title: 'Galería',
        subtitle: 'Revive las emociones de nuestras aventuras',
        photos: 'Fotos',
        videos: 'Videos',
        events: 'Eventos',
        noPhotos: 'No hay fotos disponibles',
        noVideos: 'No hay videos disponibles',
        viewAll: 'Ver todo',
        loadMore: 'Cargar más',
        backToAll: 'Volver a todas las galerías',
        noGallery: 'No hay galería para este evento',
        comingSoon: 'Fotos y videos próximamente'
      },
      about: {
        title: 'Nosotros',
        subtitle: 'La historia de Offroad Italia',
        experience: 'Años de Experiencia',
        participants: 'Participantes',
        countries: 'Países Visitados',
        reviews: 'Reseñas 5 Estrellas',
        mission: 'Nuestra misión',
        team: 'Nuestro equipo',
        history: 'Nuestra historia',
        values: 'Nuestros valores',
        partners: 'Nuestros socios'
      },
      contact: {
        title: 'Contacto',
        subtitle: 'Escríbenos para cualquier información',
        name: 'Nombre',
        email: 'Email',
        phone: 'Teléfono',
        subject: 'Asunto',
        message: 'Mensaje',
        send: 'Enviar',
        sending: 'Enviando...',
        success: '¡Mensaje enviado con éxito!',
        error: 'Error al enviar el mensaje',
        whatsapp: 'Contáctanos en WhatsApp',
        address: 'Dirección',
        hours: 'Horario',
        followUs: 'Síguenos en redes'
      },
      reviews: {
        title: 'Lo Que Dicen de Nosotros',
        subtitle: 'Más de 200 reseñas de 5 estrellas en Google',
        readMore: 'Leer más reseñas',
        writeReview: 'Dejar una reseña'
      },
      footer: {
        followUs: 'Síguenos',
        rights: 'Todos los derechos reservados',
        privacy: 'Política de Privacidad',
        cookies: 'Política de Cookies',
        terms: 'Términos y Condiciones',
        company: 'Empresa',
        support: 'Soporte',
        quickLinks: 'Enlaces Rápidos'
      },
      common: {
        loading: 'Cargando...',
        error: 'Ha ocurrido un error',
        retry: 'Reintentar',
        back: 'Atrás',
        next: 'Siguiente',
        previous: 'Anterior',
        close: 'Cerrar',
        save: 'Guardar',
        cancel: 'Cancelar',
        delete: 'Eliminar',
        edit: 'Editar',
        view: 'Ver',
        search: 'Buscar',
        filter: 'Filtrar',
        sort: 'Ordenar',
        share: 'Compartir',
        download: 'Descargar',
        upload: 'Subir',
        yes: 'Sí',
        no: 'No',
        or: 'o',
        and: 'y',
        from: 'desde',
        to: 'hasta',
        more: 'Más',
        less: 'Menos',
        showMore: 'Mostrar más',
        showLess: 'Mostrar menos',
        seeAll: 'Ver todo',
        readMore: 'Leer más'
      },
      newsletter: {
        title: 'Suscríbete al Newsletter',
        subtitle: 'Recibe novedades de próximos eventos',
        placeholder: 'Tu email',
        subscribe: 'Suscribirse',
        success: '¡Suscripción completada!',
        error: 'Error al suscribirse'
      },
      corso: {
        title: 'Curso OsmAnd',
        subtitle: 'Navegación Profesional para Enduro',
        slideOf: 'Diapositiva {current} de {total}',
        autoplay: 'Reproducción automática',
        pause: 'Pausa',
        prevSlide: 'Diapositiva anterior',
        nextSlide: 'Siguiente diapositiva',
        notAvailable: 'Curso no disponible',
        notConfigured: 'Las diapositivas del curso aún no han sido configuradas'
      },
      admin: {
        login: {
          title: 'Acceso Área Reservada',
          subtitle: 'Ingresa tu contraseña',
          password: 'Contraseña',
          placeholder: 'Ingresa la contraseña',
          submit: 'Acceder',
          loading: 'Accediendo...',
          error: '¡Contraseña incorrecta!',
          connectionError: 'Error de conexión. Por favor, reintenta.',
          forgotPassword: '¿Olvidaste la contraseña? Contacta al administrador',
          accessTypes: 'Tipos de acceso disponibles:',
          adminAccess: 'Admin: Acceso completo',
          techAccess: 'Técnico: Galerías y Estadísticas'
        },
        dashboard: {
          title: 'Panel de Admin',
          welcome: 'Bienvenido',
          manageEvents: 'Gestionar Eventos',
          createEvent: 'Nuevo Evento',
          bookings: 'Reservas',
          payments: 'Pagos',
          galleries: 'Galerías',
          media: 'Medios',
          countries: 'Países',
          statistics: 'Estadísticas',
          analytics: 'Analytics',
          course: 'Curso OsmAnd',
          logout: 'Salir',
          confirmDelete: '¿Estás seguro de que quieres eliminar',
          deleteSuccess: '¡Evento eliminado con éxito!',
          deleteError: 'Error al eliminar',
          accessRequired: 'Acceso Requerido',
          loginRequired: 'Debes iniciar sesión para acceder a esta página.',
          goToLogin: 'Ir al Login',
          topViewed: 'Eventos Más Vistos',
          views: 'vistas',
          noViews: 'Sin vistas registradas'
        },
        statistics: {
          title: 'Estadísticas',
          overview: 'Resumen',
          totalEvents: 'Total Eventos',
          totalBookings: 'Total Reservas',
          totalRevenue: 'Ingresos Totales',
          avgPerEvent: 'Promedio por Evento',
          recentBookings: 'Reservas Recientes',
          popularEvents: 'Eventos Populares',
          noData: 'Sin datos disponibles'
        },
        bookings: {
          title: 'Reservas',
          export: 'Exportar CSV',
          search: 'Buscar reserva...',
          filterByEvent: 'Filtrar por evento',
          allEvents: 'Todos los eventos',
          noBookings: 'No se encontraron reservas',
          participant: 'Participante',
          event: 'Evento',
          date: 'Fecha',
          status: 'Estado',
          amount: 'Importe',
          actions: 'Acciones'
        },
        common: {
          save: 'Guardar',
          cancel: 'Cancelar',
          delete: 'Eliminar',
          edit: 'Editar',
          create: 'Crear',
          update: 'Actualizar',
          loading: 'Cargando...',
          error: 'Error',
          success: 'Éxito',
          confirm: 'Confirmar',
          back: 'Atrás',
          actions: 'Acciones'
        }
      }
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'it',
    fallbackLng: 'it',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
